import React from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Title, Button, Loader } from "ui-kit-sahadevia";

import Statistics from "../../components/home/Statistics";
import Invoices from "../../components/home/Invoices";
import ModalInvoice from "../../components/home/ModalInvoice";
import BankStatements from "../../components/home/BankStatements";
import ModalBankStatement from "../../components/home/ModalBankStatement";

import {
  getInvoices,
  downloadInvoice,
  deleteInvoice,
} from "../../requests/invoice";
import {
  getBankStatements,
  downloadBankStatement,
  deleteBankStatement,
  getStatisticsBankStatement,
} from "../../requests/bankStatement";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      // statistics
      dataInput: [],
      dataOutput: [],
      totalInput: 0,
      totalOutput: 0,
      // invoice
      invoices: [],
      isModalInvoice: false,
      // bank statement
      bankStatements: [],
      isModalBankStatement: false,
    };
  }

  componentDidMount() {
    this.getInvoices();
    this.getBankStatements();

    getStatisticsBankStatement((result) => {
      if (result.success) {
        this.setState({
          dataInput: result.dataInput,
          dataOutput: result.dataOutput,
          totalInput: result.totalInput,
          totalOutput: result.totalOutput,
        });
      } else {
        this.setState({
          dataInput: [],
          dataOutput: [],
          totalInput: 0,
          totalOutput: 0,
        });
      }
    });
  }

  getInvoices = () => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        getInvoices((result) => {
          if (result.success) {
            this.setState({ invoices: result.data, isLoad: false });
          } else {
            this.setState({ invoices: [], isLoad: false });
          }
        });
      }
    );
  };

  downloadInvoice = (id) => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        downloadInvoice(id, (result) => {
          if (result.success) {
            let a = document.createElement("a");
            a.href = `data:${result.mime};base64,${result.base64}`;
            a.download = `${result.name}.${result.extension}`;
            a.click();
            this.setState({
              isLoad: false,
            });
          } else {
            this.setState(
              {
                isLoad: false,
              },
              () => alert("Une erreur est survenue")
            );
          }
        });
      }
    );
  };

  deleteInvoice = (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette facture")) {
      this.setState(
        {
          isLoad: true,
        },
        () => {
          deleteInvoice(id, (result) => {
            if (result.success) {
              this.getInvoices();
            } else {
              this.setState(
                {
                  isLoad: false,
                },
                () => alert("Une erreur est survenue")
              );
            }
          });
        }
      );
    }
  };

  getBankStatements = () => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        getBankStatements((result) => {
          if (result.success) {
            this.setState({ bankStatements: result.data, isLoad: false });
          } else {
            this.setState({ bankStatements: [], isLoad: false });
          }
        });
      }
    );
  };

  downloadBankStatement = (id) => {
    this.setState(
      {
        isLoad: true,
      },
      () => {
        downloadBankStatement(id, (result) => {
          if (result.success) {
            let a = document.createElement("a");
            a.href = `data:${result.mime};base64,${result.base64}`;
            a.download = `${result.name}.${result.extension}`;
            a.click();
            this.setState({
              isLoad: false,
            });
          } else {
            this.setState(
              {
                isLoad: false,
              },
              () => alert("Une erreur est survenue")
            );
          }
        });
      }
    );
  };

  deleteBankStatement = (id) => {
    if (
      window.confirm("Êtes-vous sûr de vouloir supprimer ce relevé bancaire")
    ) {
      this.setState(
        {
          isLoad: true,
        },
        () => {
          deleteBankStatement(id, (result) => {
            if (result.success) {
              this.getBankStatements();
            } else {
              this.setState(
                {
                  isLoad: false,
                },
                () => alert("Une erreur est survenue")
              );
            }
          });
        }
      );
    }
  };

  render() {
    return (
      <>
        <div style={{ padding: "1rem" }}>
          <Title title="Accueil">
            <Button
              icon={faPlus}
              text="Ajouter une facture"
              onClick={() => this.setState({ isModalInvoice: true })}
            />
            <Button
              icon={faPlus}
              text="Ajouter un relevé bancaire"
              onClick={() => this.setState({ isModalBankStatement: true })}
            />
          </Title>
        </div>
        <Statistics
          dataInput={this.state.dataInput}
          dataOutput={this.state.dataOutput}
          totalInput={this.state.totalInput}
          totalOutput={this.state.totalOutput}
        />
        <Invoices
          invoices={this.state.invoices}
          deleteInvoice={this.deleteInvoice}
          downloadInvoice={this.downloadInvoice}
          getInvoices={this.getInvoices}
        />
        <BankStatements
          bankStatements={this.state.bankStatements}
          deleteBankStatement={this.deleteBankStatement}
          downloadBankStatement={this.downloadBankStatement}
          getBankStatements={this.getBankStatements}
        />
        <ModalInvoice
          title="Ajouter une facture"
          show={this.state.isModalInvoice}
          onClose={(isReload) =>
            this.setState(
              {
                isModalInvoice: false,
              },
              () => {
                if (isReload) {
                  this.getInvoices();
                }
              }
            )
          }
        />
        <ModalBankStatement
          title="Ajouter une rélevé bancaire"
          show={this.state.isModalBankStatement}
          onClose={(isReload) =>
            this.setState(
              {
                isModalBankStatement: false,
              },
              () => {
                if (isReload) {
                  this.getBankStatements();
                }
              }
            )
          }
        />
        <Loader show={this.state.isLoad} />
      </>
    );
  }
}
